// extracted by mini-css-extract-plugin
export default {"share-button":"z8EeD"};